<figure class="not-found">
  <img class="not-found-image" [src]="assetConst.noDataFound" />
</figure>
<h3 class="n_dta">{{ 'NoDataFound' | translate }}</h3>
